"use client"

import { defineSlotRecipe } from "@chakra-ui/react"
import { menuAnatomy } from "@chakra-ui/react/anatomy"

const table = defineSlotRecipe({
  className: "hydrologiq-menu",
  slots: menuAnatomy.keys(),

  variants: {
    variant: {
      hydrologiq: {
        item: {
          color: "primary",
          fontWeight: 500,
          fontSize: "18px",
          margin: "3px 0px",
          _hover: {
            bg: "#0bc5ea",
            color: "white",
            cursor: "pointer",
            opacity: 0.75,
          },
          _highlighted: { bg: "#0bc5ea", color: "white" },
        },
        itemGroup: {},
        trigger: { _hover: { cursor: "pointer" } },
      },
    },
  },
})

export default table
